<section class="dalel-page" dir="rtl">
  <div class="page-hero">
    <div class="shell">
      <p class="page-kicker">دليل بلس</p>
      <h1>سياسة الخصوصية</h1>
    </div>
  </div>
  <div class="page-body shell">
    <ol>
      <li>
        <h2>1. المقدمة</h2>
        <p>
          نحن في دليل بلس نحترم خصوصية زوارنا وعملائنا، وملتزمون بحماية أي بيانات شخصية يتم جمعها أثناء
          استخدامك لموقعنا. تهدف هذه السياسة إلى توضيح كيفية جمع واستخدام وحماية بياناتك الشخصية.
        </p>
      </li>
      <li>
        <h2>2. البيانات التي نجمعها</h2>
        <p>
          عند استخدامك لموقعنا، قد نقوم بجمع البيانات التالية:
          <br />- البيانات الشخصية: مثل الاسم، رقم الهاتف، البريد الإلكتروني، العنوان.
          <br />- بيانات الاستخدام: مثل الصفحات التي تزورها، وقت وتاريخ الزيارة، ونوع الجهاز والمتصفح المستخدم.
          <br />- بيانات الدفع (إن وجدت): إذا كنت تشتري أي خدمة عبر الموقع، قد نحتاج إلى جمع معلومات الدفع،
          ولكننا لا نخزنها مباشرة بل تمر عبر مزود خدمة دفع آمن.
        </p>
      </li>
      <li>
        <h2>3. كيف نستخدم بياناتك؟</h2>
        <p>
          نستخدم بياناتك للأغراض التالية:
          <br />- تقديم الخدمات المطلوبة وتحسين تجربة المستخدم.
          <br />- التواصل معك بشأن طلباتك أو استفساراتك.
          <br />- تحسين محتوى الموقع وتخصيصه لاحتياجاتك.
          <br />- إرسال إشعارات أو عروض خاصة (بموافقتك).
        </p>
      </li>
      <li>
        <h2>4. حماية بياناتك</h2>
        <p>
          نحن نطبق تدابير أمان مناسبة لحماية بياناتك من الوصول غير المصرح به أو التسريب أو التعديل، ولكن لا
          يوجد نظام آمن 100% عبر الإنترنت، لذا ننصحك بعدم مشاركة معلومات حساسة بشكل علني.
        </p>
      </li>
      <li>
        <h2>5. مشاركة البيانات مع أطراف ثالثة</h2>
        <p>
          لن نبيع أو نشارك بياناتك مع أي طرف ثالث إلا في الحالات التالية:
          <br />- إذا كان ذلك ضروريًا لتقديم الخدمة المطلوبة.
          <br />- الامتثال للقوانين أو الطلبات القانونية من الجهات المختصة.
          <br />- حماية حقوق الموقع أو مستخدمينا.
        </p>
      </li>
      <li>
        <h2>6. ملفات تعريف الارتباط (Cookies)</h2>
        <p>
          نستخدم ملفات تعريف الارتباط لتحسين تجربتك على الموقع، مثل تذكر إعداداتك المفضلة وتحليل أداء الموقع.
          يمكنك ضبط متصفحك لحظر أو حذف الكوكيز، لكن ذلك قد يؤثر على بعض وظائف الموقع.
        </p>
      </li>
      <li>
        <h2>7. حقوق المستخدمين</h2>
        <p>
          يحق لك:
          <br />- طلب معرفة البيانات التي نحتفظ بها عنك.
          <br />- طلب تعديل أو حذف بياناتك.
          <br />- إلغاء الاشتراك من أي رسائل تسويقية في أي وقت.
        </p>
      </li>
      <li>
        <h2>8. تحديثات سياسة الخصوصية</h2>
        <p>
          قد نقوم بتحديث هذه السياسة من وقت لآخر، وسيتم نشر أي تغييرات على هذه الصفحة. نوصي بمراجعة السياسة
          بانتظام لتظل على اطلاع بالتحديثات.
        </p>
      </li>
      <li>
        <h2>9. التواصل معنا</h2>
        <p>
          إذا كان لديك أي استفسارات حول سياسة الخصوصية، يمكنك التواصل معنا عبر:
          <br />- البريد الإلكتروني: info&#64;dalel.sa
          <br />- رقم الهاتف: 0503811476
        </p>
      </li>
    </ol>
  </div>
</section>
